<!-- Maintain correct heading order h1 - h2 - h3 for accessibility -->
<ng-container *ngIf="(currentStage$ | async).stage !== Stage.FLIGHTS">
  <div class="white-bg pr-medium border rounded-medium mobile-bleed">
    <ng-container *ngIf="(currentStage$ | async).stage !== Stage.PASSENGERS; else passengerSelectionForm">
      <h2
        *ngIf="(currentStage$ | async).stage === Stage.REVIEW"
        class="ms-xsmall-b nordic-blue-900-text ms-medium-b font-heading-4"
      >
        {{ 'oneUpgrade.upgradeSelection.passengers' | finLocalization }}
      </h2>
      <div
        *ngIf="passengers$ | async as passengers"
        class="selected-passengers flex flex--column flex--align-start mr-xsmall-b"
      >
        <div
          *ngFor="let selectedPassenger of selectedPassengers$ | async"
          class="selected-passenger ms-medium-b flex flex--middle"
        >
          <fcom-icon
            class="ms-xsmall-r icon-medium nordic-blue-900-text"
            [name]="SvgLibraryIcon.SINGLE_PAX"
          ></fcom-icon>

          <span class="font-body-1 regular-type privatedata" data-hj-suppress>
            {{ getSelectedName(selectedPassenger) | async }}
          </span>
        </div>
      </div>

      <div *ngIf="(passengers$ | async).length > 1" class="align-right">
        <button
          class="font-body-1 bold-type nordic-blue-900-text underline blue-light-hover"
          (click)="onChangePassengers()"
        >
          {{ 'oneUpgrade.upgradeSelection.change' | finLocalization }}
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #passengerSelectionForm>
  <form *ngIf="passengerForm" [formGroup]="passengerForm">
    <div class="passengers flex flex--column flex--align-start" role="group" formArrayName="passengers">
      <ng-container *ngFor="let control of passengerControls; let i = index">
        <fcom-checkbox
          *ngIf="getPassengerDetails(i) | async as passenger"
          class="ms-large-b"
          [name]="i.toString()"
          [formControlName]="i"
          (change)="onPassengerToggle$.next({ selected: $event, passengerId: passenger.passengerId })"
        >
          <span class="font-body-1 medium-type privatedata" data-hj-suppress>
            {{ getSelectedName(passenger.passengerId) | async }}
            <span *ngIf="passenger.child" data-testid="upgrade-selection-passenger-child"
              >({{ 'passenger.child' | finLocalization }})</span
            >
          </span>
        </fcom-checkbox>
      </ng-container>
    </div>

    <div class="mr-small-t" *ngIf="showPaxLimit$ | async">
      <fcom-notification [layout]="NotificationLayout.BLOCK" class="block">
        {{ seatInfoText | async }}
      </fcom-notification>
    </div>
  </form>
</ng-template>
